import StatisticalAnalysisSkeletonDossierNavigationItems from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-dossier-navigation-items/statistical-analysis-skeleton-dossier-navigation-items.vue'
import StatisticalAnalysisSkeletonDelaysAndResponseTimesDossierTrackingItems from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-delays-and-response-times-dossier/statistical-analysis-skeleton-delays-and-response-times-dossier-tracking-items/statistical-analysis-skeleton-delays-and-response-times-dossier-tracking-items.vue'
import { Vue, Component } from 'vue-property-decorator'

@Component({
    components: {
        StatisticalAnalysisSkeletonDossierNavigationItems,
        StatisticalAnalysisSkeletonDelaysAndResponseTimesDossierTrackingItems
    }
})
export default class StatisticalAnalysisSkeletonDelaysAndResponseTimesDossierBase extends Vue {}
